var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 0.5H2.16667C1.24167 0.5 0.5 1.25 0.5 2.16667V13.8333C0.5 14.75 1.24167 15.5 2.16667 15.5H13.8333C14.75 15.5 15.5 14.75 15.5 13.8333V3.83333L12.1667 0.5ZM13.8333 13.8333H2.16667V2.16667H11.475L13.8333 4.525V13.8333ZM8 8C6.61667 8 5.5 9.11667 5.5 10.5C5.5 11.8833 6.61667 13 8 13C9.38333 13 10.5 11.8833 10.5 10.5C10.5 9.11667 9.38333 8 8 8ZM3 3H10.5V6.33333H3V3Z",
    fill: "#4B6681"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave16);
export default __webpack_public_path__ + "97120/static/media/save16.07e7b33adbaf4da875136d5d35c87ede.svg";
export { ForwardRef as ReactComponent };